import { captureMessage } from '@sentry/react';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { isEmpty } from 'lodash';
import { initReactI18next } from 'react-i18next';

import config from './config';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    backend: {
      loadPath: '/lang/{{lng}}/{{ns}}.json',
    },
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: [
      'account',
      'common',
      'location',
      'activity',
      'chargebee',
      'components',
      'controlling',
      'chains',
      'errors',
      'forms',
      'pages',
      'promotions',
      'sidebar',
      'service_record',
      'service_history_request',
      'user',
      'workshop',
      'workshop_update_request',
      'workshop_verification_request',
      'b2c_service_history_request',
      'documents',
      'promotion',
      'announcements',
      'tasks',
      'legal_documents',
      'b2c_verification_request',
      'b2c_verification',
    ],
    returnEmptyString: false,
    debug: false,
    saveMissing: true,
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    //for more options available https://www.npmjs.com/package/i18next-browser-languagedetector?activeTab=readme
    detection: {
      htmlTag: document.documentElement,
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
    },
    // eslint-disable-next-line
    missingKeyHandler: (lngs, ns, key) => {
      !isEmpty(lngs) && !lngs.includes('cimode') && captureMessage(`Missing translation key: ${lngs}:${ns}:${key}`);
    },
    appendNamespaceToCIMode: true,
  });

if (config.appEnv === 'local' && import.meta.hot) {
  import.meta.hot.on('locales-update', () => {
    i18n.reloadResources().then(() => {
      i18n.changeLanguage(i18n.language);
    });
  });
}

//reset the language in the html tag
i18n.on('languageChanged', (lng) => {
  document.documentElement.setAttribute('lang', lng);
});
export default i18n;
